import type { Film } from "@/mocks/films";

export const TYPE_LABELS: Record<string, string> = {
  movie: "电影",
  tv: "电视剧",
  short: "短片",
};

export function typeLabel(type: string): string {
  return TYPE_LABELS[type] ?? "影视";
}

export function categoryPath(type: string): string {
  return `/category/${type}`;
}

export function getRelatedFilms(current: Film, all: Film[], limit = 6): Film[] {
  const scored = all
    .filter((f) => f.id !== current.id)
    .map((f) => {
      let score = 0;
      if (f.director === current.director) score += 3;
      if (f.type === current.type) score += 2;
      const sharedGenres = f.genres.filter((g) => current.genres.includes(g)).length;
      score += sharedGenres;
      return { film: f, score };
    })
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score || b.film.popularity - a.film.popularity);
  return scored.slice(0, limit).map((item) => item.film);
}

export function matchKeyword(film: Film, keyword: string): boolean {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return true;
  const haystack = [
    film.title,
    film.director,
    film.synopsis,
    film.region,
    ...film.cast,
    ...film.genres,
  ]
    .join(" ")
    .toLowerCase();
  return haystack.includes(kw);
}